import React, { useState, useEffect, useContext } from "react";
import "../../App.css"; // Import global styles
import AffordableHousingImage from "../../images/category Images/Affordable_Housing.png"; // Importing the image
import AccidentEmergencyImage from "../../images/category Images/Accident_Emergency.png"; // Importing the image
import AdventureImage from "../../images/category Images/Adventure.png"; // Importing the image
import AbstainDetoxImage from "../../images/category Images/Abstain_Detox.png"; // Importing the image
import BusinessConditionImage from "../../images/category Images/Business_Condition.png"; // Importing the image
import BetterEducationImage from "../../images/category Images/Better_Education.png"; // Importing the image
import BucketListImage from "../../images/category Images/Bucket_List.png"; // Importing the image
import LawEnforcementImage from "../../images/category Images/Law_Enforcement.png"; // Importing the image
import CancerImage from "../../images/category Images/Cancer.png"; // Importing the image
import ChallengesImage from "../../images/category Images/Challenges.png"; // Importing the image
import CelebrationImage from "../../images/category Images/Celebrations.png"; // Importing the image
import CyclingImage from "../../images/category Images/Cycling.png"; // Importing the image
import CutShaveImage from "../../images/category Images/Cut_Shave.png"; // Importing the image
import DefenseSecurityImage from "../../images/category Images/Defense_Security.png"; // Importing the image
import DisabilityImage from "../../images/category Images/Disability.png"; // Importing the image
import DisasterReliefImage from "../../images/category Images/Disaster_Relief.png"; // Importing the image
import EconomicStabilityImage from "../../images/category Images/Economic_Stability.png"; // Importing the image
import FairWorkplaceImage from "../../images/category Images/Fair_Workplace.png"; // Importing the image
import FamilySupportImage from "../../images/category Images/Family_Children_Needs.png"; // Importing the image
import HealthHospitalImage from "../../images/category Images/Health_Hospital.png"; // Importing the image
import HonestGovernmentImage from "../../images/category Images/Honest_Government.png"; // Importing the image
import HelpFriendImage from "../../images/category Images/Help_Friends.png"; // Importing the image
import IncreasingMigrationImage from "../../images/category Images/Increasing_Migration.png"; // Importing the image
import InMemoryImage from "../../images/category Images/In_Memory.png"; // Importing the image
import LowerFamilyTaxImage from "../../images/category Images/Lower_Family_Tax.png"; // Importing the image
import MarathonsRunsImage from "../../images/category Images/Marathons_Runs.png"; // Importing the image
import PetsAnimalsImage from "../../images/category Images/Pets_Animals.png"; // Importing the image
import ProjectPoliticalAdvocacyImage from "../../images/category Images/Project_Politics_Advocacy.png"; // Importing the image
import RuralNeedsImage from "../../images/category Images/Rural_Needs.png"; // Importing the image
import ReducingUnemploymentImage from "../../images/category Images/Reducing_Unemployment.png"; // Importing the image
import ReducingMigrationImage from "../../images/category Images/Reducing_Migration.png"; // Importing the image
import ElderlySupportImage from "../../images/category Images/Elderly_Support.png"; // Importing the image
import SportsClubsImage from "../../images/category Images/Sports_Clubs.png"; // Importing the image
import TacklingClimateChangeImage from "../../images/category Images/Tackling_Climate_Change.png"; // Importing the image
import VolunteersImage from "../../images/category Images/Volunteers.png"; // Importing the image

import { UserContext } from "../context/UserContext";

const AddProject = ({ onClose, project = null, handleSubmit }) => {
  // Helper function to format date to dd/mm/yyyy
  const formatDate = (date) => {
    if (!date) return "";
    const parsedDate = new Date(date); // Parse the date string
    const day = String(parsedDate.getDate()).padStart(2, "0");
    const month = String(parsedDate.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = parsedDate.getFullYear();
    return `${day}/${month}/${year}`;
  };
  
  
  const { emailId } = useContext(UserContext);
  const [projectTitle, setProjectTitle] = useState(
    project?.project_title || ""
  );
  const [selectedCategory, setSelectedCategory] = useState(
    project?.category || ""
  );
  const [targetAmount, setTargetAmount] = useState(
    project?.target_amount || ""
  );
  const [currency, setCurrency] = useState(project?.currency || "AUD");
  const [description, setDescription] = useState(project?.description || "");
  const [endDate, setEndDate] = useState(
    project ? formatDate(project.end_date) : ""
  );

  const [imageFile, setImageFile] = useState(null);
  const [uploadedImageUrl, setUploadedImageUrl] = useState(
    project?.image_url || ""
  );
  const [currentPage, setCurrentPage] = useState(project ? 2 : 1); // Default to page 2 for editing

  const [mediaFile, setMediaFile] = useState(null);
  const [mediaType, setMediaType] = useState(null);
  const [mediaUrl, setMediaUrl] = useState(project?.media_url || "");

  const currencies = ["AUD"]; // Currency options

  const [endDay, setEndDay] = useState("");
const [endMonth, setEndMonth] = useState("");
const [endYear, setEndYear] = useState("");

  // Add these states at the top with other state declarations
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  // Add new states for banking details
  const [accountName, setAccountName] = useState(project?.account_name || "");
  const [accountNumber, setAccountNumber] = useState(project?.account_number || "");
  const [bsbNumber, setBsbNumber] = useState(project?.bsb || "");

  // Updated categories with the correct image import
  const categories = [
    { name: "Affordable Housing", img: AffordableHousingImage },
    { name: "Emergency & Accident", img: AccidentEmergencyImage },
    { name: "Adventure", img: AdventureImage },
    { name: "Abstain & Detox", img: AbstainDetoxImage },
    { name: "Better Business Condition", img: BusinessConditionImage },
    { name: "Better Education", img: BetterEducationImage },
    { name: "Bucket List", img: BucketListImage },
    { name: "Law Enforcement", img: LawEnforcementImage },
    { name: "Cancer", img: CancerImage },
    { name: "Challenges", img: ChallengesImage },
    { name: "Celebration", img: CelebrationImage },
    { name: "Cycling", img: CyclingImage },
    { name: "Cut & Shave", img: CutShaveImage },
    { name: "Defence & Security", img: DefenseSecurityImage },
    { name: "Disability", img: DisabilityImage },
    { name: "Disaster Relief", img: DisasterReliefImage },
    { name: "Economic Stability", img: EconomicStabilityImage },
    { name: "Fair Workplace", img: FairWorkplaceImage },
    { name: "Family, Children Needs", img: FamilySupportImage },
    { name: "Health & Hospital", img: HealthHospitalImage },
    { name: "Honest Government", img: HonestGovernmentImage },
    { name: "Help Friends", img: HelpFriendImage },
    { name: "Increasing Migration", img: IncreasingMigrationImage },
    { name: "In Memory", img: InMemoryImage },
    { name: "Lower Family Tax", img: LowerFamilyTaxImage },
    { name: "Marathons & Runs", img: MarathonsRunsImage },
    { name: "Pets & Animals", img: PetsAnimalsImage },
    {
      name: "Projects,Political & Advocacy",
      img: ProjectPoliticalAdvocacyImage,
    },
    { name: "Rural Needs", img: RuralNeedsImage },
    { name: "Reducing Unemployment", img: ReducingUnemploymentImage },
    { name: "Reducing Migration", img: ReducingMigrationImage },
    { name: "Elderly Support", img: ElderlySupportImage },
    { name: "Sports & Clubs", img: SportsClubsImage },
    { name: "Tackling Climate Change", img: TacklingClimateChangeImage },
    { name: "Volunteers", img: VolunteersImage },
  ];

  // Prevent negative amounts in the Target Amount field
  const handleTargetAmountChange = (e) => {
    const value = e.target.value;
    if (value >= 0) {
      setTargetAmount(value);
    }
  };

  // Handle end date selection
  const handleEndDateChange = (day, month, year) => {
    if (!day || !month || !year) {
      setEndDate("");
      return;
    }

    // Format the date properly
    const formattedDate = `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
    setEndDate(formattedDate);
  };
  
  
  // Navigate to the next page
  const handleNextPage = () => {
    if (currentPage === 1 && !selectedCategory) {
      alert("Please select a category!");
      return;
    }
    setCurrentPage(2); // Move to page 2
  };

  // Navigate to the previous page
  const handlePreviousPage = () => {
    setCurrentPage(1); // Move back to page 1
  };

  // Add this function to handle image upload to S3
  const uploadImageToS3 = async (file) => {
    const formData = new FormData();
    formData.append("image", file);

    try {
      const response = await fetch("/api/upload-s3", {
        method: "POST",
        body: formData,
      });

      if (!response.ok) throw new Error("Image upload failed");

      const data = await response.json();
      return data.imageUrl;
    } catch (error) {
      console.error("Error uploading image:", error);
      throw error;
    }
  };

  // Add validation function
  const validateFile = (file) => {
    const allowedImageTypes = ['image/jpeg', 'image/png', 'image/gif'];
    const allowedVideoTypes = ['video/mp4', 'video/quicktime', 'video/x-msvideo'];
    const maxSize = 500 * 1024 * 1024; // 100MB

    if (![...allowedImageTypes, ...allowedVideoTypes].includes(file.type)) {
      alert('Invalid file type. Only images (JPG, PNG, GIF) and videos (MP4, MOV, AVI) are allowed.');
      return false;
    }

    if (file.size > maxSize) {
      alert('File is too large. Maximum size is 500MB.');
      return false;
    }

    return true;
  };

  // Update file input handler
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && validateFile(file)) {
      setMediaFile(file);
      setMediaType(file.type);
    }
  };

  // Update upload function
  const uploadMediaToS3 = async (file) => {
    const formData = new FormData();
    formData.append("media", file);

    try {
      const response = await fetch("/api/upload-s3", {
        method: "POST",
        body: formData,
      });

      if (!response.ok) throw new Error("Media upload failed");

      const data = await response.json();
      return { url: data.mediaUrl, type: data.mediaType };
    } catch (error) {
      console.error("Error uploading media:", error);
      throw error;
    }
  };

  // Add validation handlers for BSB and Account numbers
  const handleBsbNumberChange = (e) => {
    const value = e.target.value.replace(/\D/g, ''); // Only allow digits
    if (value.length <= 6) { // Limit to 6 digits
      setBsbNumber(value);
    }
  };

  const handleAccountNumberChange = (e) => {
    const value = e.target.value.replace(/\D/g, ''); // Only allow digits
    if (value.length <= 10) { // Limit to 10 digits
      setAccountNumber(value);
    }
  };

  //TODO
  // Save project on submission
  const handleSaveProject = async () => {
    console.log(projectTitle, selectedCategory, targetAmount, description, endDate, mediaFile);
    if (!project && (!selectedCategory || !projectTitle || !targetAmount || !description || !endDate || !mediaFile)) {
      alert("Please fill out all fields to add a new project!");
      return;
    }

    setIsSubmitting(true);
    setUploadProgress(0);
    
    try {
      let imageUrl = uploadedImageUrl;
      let mediaData = { url: mediaUrl, type: mediaType };

      // Start with 10% progress for initialization
      setUploadProgress(10);

      if (imageFile) {
        // Update progress to 30% when starting image upload
        setUploadProgress(30);
        imageUrl = await uploadImageToS3(imageFile);
      }

      // Update progress to 50% after image upload
      setUploadProgress(50);

      if (mediaFile) {
        // Update progress to 70% when starting media upload
        setUploadProgress(70);
        mediaData = await uploadMediaToS3(mediaFile);
      }

      // Update progress to 80% after media upload
      setUploadProgress(80);

      const formData = {
        project_title: projectTitle || project?.project_title,
        category: selectedCategory || project?.category,
        target_amount: targetAmount ? parseFloat(targetAmount) : project?.target_amount,
        currency: currency || project?.currency,
        description: description || project?.description,
        image_url: mediaData.url,
        media_type: mediaData.type,
        end_date: endDate || project?.end_date,
        email_id: emailId,
        type: 'project',
        account_name: accountName || project?.account_name,
        account_number: accountNumber || project?.account_number,
        bsb: bsbNumber || project?.bsb,
      };

      // Update progress to 90% before final submission
      setUploadProgress(90);

      let response;
      if (project) {
        response = await fetch(`/api/projectlist/${project.project_id}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        });
      } else {
        response = await fetch("/api/projectlist", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        });
      }

      if (response.status === 500) {
        const errorData = await response.json();
        alert(`❌ Submission flagged for inappropriate content, please use the "contact us" form to contact admin to submit the project manually`);
        return;
      }

      if (!response.ok) {
        throw new Error(`Failed to ${project ? "update" : "create"} project`);
      }

      // Set progress to 100% on successful completion
      setUploadProgress(100);

      const result = await response.json();
      alert(`✅ Project '${projectTitle}' ${project ? "updated" : "added"} successfully!`);

      onClose();
    } catch (error) {
      console.error("🚨 Error submitting form:", error);
      alert("An unexpected error occurred. Please try again.");
    } finally {
      // Add a small delay before closing the progress bar to make it visible
      setTimeout(() => {
        setIsSubmitting(false);
        setUploadProgress(0);
      }, 1000);
    }
  };
  

  return (
    <div
      className="popup-section"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent background
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 999,
      }}
    >
      <div
        className="popup-container"
        style={{
          backgroundColor: "#fff",
          borderRadius: "10px",
          padding: "20px",
          width: "95%", // Increased width
          maxWidth: "900px", // Increased max-width
          maxHeight: "90vh", // Set a maximum height
          overflowY: "auto", // Enable scrolling if content overflows
          boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
          position: "relative",
        }}
      >
        <h3 style={{ textAlign: "center", marginBottom: "20px" }}>
          {project ? "Edit Project" : "Add New Project"}
        </h3>

        {/* Close Button */}
        <button
          onClick={onClose} // Ensure this is correctly passed and invoked
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            background: "none",
            border: "none",
            fontSize: "1.5rem",
            cursor: "pointer",
          }}
        >
          &times;
        </button>

        {/* Multi-page Form */}
        {currentPage === 1 &&
          !project && ( // Only show this step if adding a new project
            <form>
              {/* Note about required fields */}
              <div style={{ marginBottom: "15px", fontSize: "12px" }}>
                <p><span style={{ color: "red" }}>*</span> indicates required fields. All fields must be filled out to submit the form.</p>
              </div>
              
              {/* Page 1: Categories */}
              <div style={{ marginBottom: "15px", textAlign: "center" }}>
                <p style={{ fontSize: "14px", fontWeight: "bold" }}>
                  Select a Category: <span style={{ color: "red" }}>*</span>
                </p>
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    margin: "0 auto",
                    textAlign: "center",
                  }}
                >
                  <tbody>
                    {Array.from({ length: 7 }).map((_, rowIndex) => (
                      <tr key={rowIndex}>
                        {categories
                          .slice(rowIndex * 5, rowIndex * 5 + 5) // Extract 5 items for each row
                          .map((category, colIndex) => (
                            <td
                              key={colIndex}
                              style={{
                                padding: "10px",
                                border: "1px solid white",
                                borderRadius: "5px",
                                backgroundColor:
                                  selectedCategory === category.name
                                    ? "#007bff"
                                    : "white",
                                color:
                                  selectedCategory === category.name
                                    ? "white"
                                    : "#333",
                                cursor: "pointer",
                                height: "120px", // Set to match the image's height
                                verticalAlign: "middle", // Center content vertically
                              }}
                              onClick={() => setSelectedCategory(category.name)} // Set the selected category
                            >
                              {category.img ? (
                                <img
                                  src={category.img}
                                  alt={category.name}
                                  style={{
                                    width: "90px", // Adjusted to match aspect ratio
                                    height: "90px", // Adjusted to match aspect ratio
                                    marginBottom: "5px",
                                    display: "block",
                                    margin: "0 auto",
                                  }}
                                />
                              ) : null}
                              {category.name}
                            </td>
                          ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Navigation Buttons */}
              {!project && ( // Only show "Next" button in Add mode
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: "20px",
                  }}
                >
                  <button
                    type="button"
                    style={{
                      padding: "10px 20px",
                      backgroundColor: "#007bff",
                      color: "white",
                      border: "none",
                      borderRadius: "5px",
                      cursor: "pointer",
                    }}
                    onClick={handleNextPage}
                  >
                    Next
                  </button>
                </div>
              )}
            </form>
          )}

        {currentPage === 2 && (
          <form>
            {/* Note about required fields */}
            <div style={{ marginBottom: "15px", fontSize: "12px" }}>
              <p><span style={{ color: "red" }}>*</span> indicates required fields. All fields must be filled out to submit the form.</p>
            </div>
            
            {/* Page 2: Project Details */}
            <div style={{ marginBottom: "15px" }}>
              <label
                htmlFor="projectTitle"
                style={{
                  display: "block",
                  fontSize: "14px",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Project Title: <span style={{ color: "red" }}>*</span>
              </label>
              <input
                id="projectTitle"
                type="text"
                value={projectTitle}
                onChange={(e) => setProjectTitle(e.target.value)}
                placeholder="Enter project title"
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "5px",
                  border: "1px solid #ccc",
                  backgroundColor: project ? "#f8f9fa" : "white", // Subtle gray background for read-only
                  cursor: project ? "not-allowed" : "text", // Change cursor for read-only
                }}
                readOnly={!!project} // Makes the field read-only if the component is in edit mode
              />
              {project && (
                <small
                  style={{
                    color: "#6c757d",
                    fontSize: "12px",
                    marginTop: "5px",
                    display: "block",
                  }}
                >
                  Project title cannot be changed while editing.
                </small>
              )}
            </div>

            {/* Target Amount */}
            <div style={{ marginBottom: "15px" }}>
              <label
                htmlFor="targetAmount"
                style={{
                  display: "block",
                  fontSize: "14px",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Your Target Amount: <span style={{ color: "red" }}>*</span>
              </label>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  padding: "10px",
                }}
              >
                <select
                  value={currency}
                  onChange={(e) => setCurrency(e.target.value)}
                  style={{
                    border: "none",
                    background: "none",
                    color: "#00d4ff",
                    fontWeight: "bold",
                    outline: "none",
                    width: "60px", // Compact dropdown width
                    textAlign: "center",
                    appearance: "none", // For consistent dropdown styling
                  }}
                >
                  {currencies.map((cur) => (
                    <option key={cur} value={cur}>
                      {cur}
                    </option>
                  ))}
                </select>
                <span
                  style={{
                    margin: "0 10px", // Spacing around the separator
                    color: "#ccc", // Light gray for the separator
                    fontWeight: "bold",
                  }}
                >
                  |
                </span>
                <input
                  id="targetAmount"
                  type="number"
                  value={targetAmount}
                  onChange={handleTargetAmountChange}
                  placeholder="Enter target amount"
                  style={{
                    border: "none",
                    outline: "none",
                    flex: 1, // Let the input field take up remaining space
                    fontSize: "14px",
                  }}
                />
              </div>
            </div>

            {/* End Date */}
            <div style={{ marginBottom: "15px", textAlign: "left" }}>
              <label
                htmlFor="endDate"
                style={{
                  display: "block",
                  fontSize: "14px",
                  marginBottom: "10px",
                  fontWeight: "bold",
                }}
              >
                End Date: <span style={{ color: "red" }}>*</span>
              </label>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start", // Align everything to the left
                  gap: "10px",
                }}
              >
                {/* Day Dropdown */}
                <div style={{ textAlign: "center" }}>
                  <label
                    htmlFor="endDay"
                    style={{
                      fontSize: "12px",
                      display: "block",
                      marginBottom: "5px",
                    }}
                  >
                    Day
                  </label>
                  <select
                    id="endDay"
                    value={endDay}
                    onChange={(e) => {
                      const updatedDay = e.target.value;
                      setEndDay(updatedDay);
                      handleEndDateChange(updatedDay, endMonth, endYear);
                    }}
                    style={{
                      width: "80px",
                      height: "40px",
                      textAlign: "center",
                      border: "1px solid #000",
                      borderRadius: "5px",
                      fontSize: "14px",
                      cursor: "pointer",
                    }}
                  >
                    <option value="">DD</option>
                    {Array.from({ length: 31 }, (_, i) => i + 1).map((day) => (
                      <option key={day} value={day}>
                        {day}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Dash Separator */}
                <span style={{ fontSize: "18px", fontWeight: "bold" }}>-</span>

                {/* Month Dropdown */}
                <div style={{ textAlign: "center" }}>
                  <label
                    htmlFor="endMonth"
                    style={{
                      fontSize: "12px",
                      display: "block",
                      marginBottom: "5px",
                    }}
                  >
                    Month
                  </label>
                  <select
                    id="endMonth"
                    value={endMonth}
                    onChange={(e) => {
                      const updatedMonth = e.target.value;
                      setEndMonth(updatedMonth);
                      handleEndDateChange(endDay, updatedMonth, endYear);
                    }}
                    style={{
                      width: "80px",
                      height: "40px",
                      textAlign: "center",
                      border: "1px solid #000",
                      borderRadius: "5px",
                      fontSize: "14px",
                      cursor: "pointer",
                    }}
                  >
                    <option value="">MM</option>
                    {Array.from({ length: 12 }, (_, i) => i + 1).map((month) => (
                      <option key={month} value={month}>
                        {month}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Dash Separator */}
                <span style={{ fontSize: "18px", fontWeight: "bold" }}>-</span>

                {/* Year Dropdown */}
                <div style={{ textAlign: "center" }}>
                  <label
                    htmlFor="endYear"
                    style={{
                      fontSize: "12px",
                      display: "block",
                      marginBottom: "5px",
                    }}
                  >
                    Year
                  </label>
                  <select
                    id="endYear"
                    value={endYear}
                    onChange={(e) => {
                      const updatedYear = e.target.value;
                      setEndYear(updatedYear);
                      handleEndDateChange(endDay, endMonth, updatedYear);
                    }}
                    style={{
                      width: "100px",
                      height: "40px",
                      textAlign: "center",
                      border: "1px solid #000",
                      borderRadius: "5px",
                      fontSize: "14px",
                      cursor: "pointer",
                    }}
                  >
                    <option value="">YYYY</option>
                    {Array.from({ length: 10 }, (_, i) => new Date().getFullYear() + i).map((year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Display the formatted date */}
              {endDate && (
                <p
                  style={{
                    fontSize: "12px",
                    color: "#6c757d",
                    marginTop: "10px",
                  }}
                >
                  Selected Date: {endDate}
                </p>
              )}
            </div>

            <div style={{ marginBottom: "15px" }}>
              <label
                htmlFor="description"
                style={{
                  display: "block",
                  fontSize: "14px",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Description: <span style={{ color: "red" }}>*</span>
              </label>
              <textarea
                id="description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Enter project description"
                rows="4"
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "5px",
                  border: "1px solid #ccc",
                  resize: "none",
                }}
              />
            </div>

            {/* Image Upload or URL */}
            {/* <div style={{ marginBottom: "15px" }}>
              <label
                htmlFor="imageUpload"
                style={{
                  display: "block",
                  fontSize: "14px",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Upload Project Image:
              </label>
              <input
                id="imageUpload"
                type="file"
                accept="image/*"
                onChange={(e) => setImageFile(e.target.files[0])}
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "5px",
                  border: "1px solid #ccc",
                }}
              />
            </div> */}

            {/* Media Upload */}
            <div style={{ marginBottom: "15px" }}>
              <label
                htmlFor="mediaUpload"
                style={{
                  display: "block",
                  fontSize: "14px",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Upload Project Image or Video, max 500MB, Acceppted formats: jpeg, png, GIF, MP4, quicktime, x-msvideo: <span style={{ color: "red" }}>*</span>
              </label>
              <input
                id="mediaUpload"
                type="file"
                accept="image/*,video/*"
                onChange={handleFileChange}
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "5px",
                  border: "1px solid #ccc",
                }}
              />
              {mediaFile && (
                <div style={{ marginTop: "10px" }}>
                  {mediaType?.startsWith('image/') ? (
                    <img 
                      src={URL.createObjectURL(mediaFile)} 
                      alt="Preview" 
                      style={{ maxWidth: "200px" }} 
                    />
                  ) : (
                    <video 
                      controls 
                      style={{ maxWidth: "200px" }}
                    >
                      <source src={URL.createObjectURL(mediaFile)} type={mediaType} />
                      Your browser does not support the video tag.
                    </video>
                  )}
                </div>
              )}
            </div>

            {/* Add new banking fields before the submit button */}
            <div style={{ marginBottom: "15px" }}>
              <label
                htmlFor="accountName"
                style={{
                  display: "block",
                  fontSize: "14px",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Account Name: <span style={{ color: "red" }}>*</span>
              </label>
              <input
                id="accountName"
                type="text"
                value={accountName}
                onChange={(e) => setAccountName(e.target.value)}
                placeholder="Enter account name"
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "5px",
                  border: "1px solid #ccc",
                }}
              />
            </div>

            <div style={{ marginBottom: "15px" }}>
              <label
                htmlFor="accountNumber"
                style={{
                  display: "block",
                  fontSize: "14px",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Account Number (9-10 digits): <span style={{ color: "red" }}>*</span>
              </label>
              <input
                id="accountNumber"
                type="text"
                value={accountNumber}
                onChange={handleAccountNumberChange}
                placeholder="Enter account number"
                minLength="9"
                maxLength="10"
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "5px",
                  border: "1px solid #ccc",
                }}
              />
            </div>

            <div style={{ marginBottom: "15px" }}>
              <label
                htmlFor="bsbNumber"
                style={{
                  display: "block",
                  fontSize: "14px",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                BSB Number (6 digits): <span style={{ color: "red" }}>*</span>
              </label>
              <input
                id="bsbNumber"
                type="text"
                value={bsbNumber}
                onChange={handleBsbNumberChange}
                placeholder="Enter BSB number"
                minLength="6"
                maxLength="6"
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "5px",
                  border: "1px solid #ccc",
                }}
              />
            </div>

            {/* Navigation Buttons */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <button
                type="button"
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#ffc107",
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
                onClick={handlePreviousPage}
              >
                Back
              </button>
              <button
                type="button"
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#007bff",
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
                onClick={handleSaveProject}
              >
                Submit
              </button>
            </div>
          </form>
        )}
      </div>

      {/* Add this progress bar overlay right before the closing div of your return statement */}
      {isSubmitting && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "30px",
              borderRadius: "10px",
              textAlign: "center",
              width: "300px",
            }}
          >
            <div style={{ marginBottom: "20px" }}>
              <div style={{ marginBottom: "10px", fontWeight: "bold" }}>
                Uploading your project...
              </div>
              <div
                style={{
                  width: "100%",
                  height: "20px",
                  backgroundColor: "#f0f0f0",
                  borderRadius: "10px",
                  overflow: "hidden",
                }}
              >
                <div
                  style={{
                    width: `${uploadProgress}%`,
                    height: "100%",
                    backgroundColor: "#4CAF50",
                    borderRadius: "10px",
                    transition: "width 0.3s ease-in-out",
                  }}
                />
              </div>
              <div style={{ marginTop: "10px", fontSize: "14px" }}>
                {uploadProgress}% Complete
              </div>
            </div>
            <div style={{ color: "#666", fontSize: "14px" }}>
              Please wait while we process your project...
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddProject;
